import FavouriteProduct from './code/Scripts/components/WishList/favourite/favouriteProduct.vue';
import FavouriteArticle from './code/Scripts/components/WishList/favourite/favouriteArticle.vue';
import WishlistedArticle from './code/Scripts/components/WishList/wishlist/wishlistedArticle.vue';
import HeaderWishlist from './code/Scripts/components/WishList/headerWishlist/headerWishlist.vue';
import WishlistedProduct from './code/Scripts/components/WishList/wishlist/wishlistedProduct.vue';

export default {
  components: {
    FavouriteProduct,
    FavouriteArticle,
    WishlistedArticle,
    HeaderWishlist,
    WishlistedProduct,
  },
};
